/**
 * An instance of `Intl.NumberFormat` that is used to format numbers 
 * as USD currency strings with a maximum of 2 fractional digits.
 * @type {Intl.NumberFormat}
 */
const cashFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 2,
});

/**
 * Formats a number as a USD currency string.
 * @param {number} value - The number to format.
 * @returns {string} The formatted currency string.
 */
export const Cash = (value) => cashFormatter.format(value);



/**
 * Logs the input to the console if the environment is set to development.
 * @param {...*} input - The input to log.
 * @returns {void}
 */
export const log = (...input) => process.env.NODE_ENV === 'development' && console.log('➡️LOG➡️', [...input])



/**
 * Sets a cookie with a specified name, value, and expiration time.
 * 
 * @param {string} name - The name of the cookie.
 * @param {string} value - The value to be stored in the cookie.
 * @param {number} [days] - The number of days until the cookie expires. If not provided, the cookie will become a session cookie.
 * @returns {void}
 */
export function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/; domain=lifeboostcoffee.com";
}

/**
 * Retrieves the value of a cookie by its name.
 * 
 * @param {string} name - The name of the cookie to retrieve.
 * @returns {string|null} Returns the value of the cookie if found, or null if not found.
 */
export function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

/**
 * Deletes a cookie by setting its value to empty and its expiration date to a past date.
 * 
 * @param {string} name - The name of the cookie to erase.
 * @returns {void}
 */
export function eraseCookie(name) {
    document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}


export const forceNoFixed = () => useState('forceNoFixed', () => false);


export const useShutWarn = () => {
    ///Supress Stupid Warnings from vercel "nuxt/image"
    const originalWarn = console.warn
    console.warn = function(message, ...args) {

        if (message.includes('A defined width should be provided') || message.includes('The width being used')) {
            // Ignore the specific warnings
            return
        }
        originalWarn.call(console, message, ...args)
    }
}


export const isDev = import.meta.dev;


export const scrollPosition = (mobilePosition = 'bottom') => {
    return window.innerWidth > 1024 ? 'top' : mobilePosition
}


export const getSellingPlan = async (handle, sellingPlanName) => {
  try {
    const response = await $fetch(`/api/shopifyProduct?handle=${handle}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        },
    });
    const data = JSON.parse(response);
    if (!data || !data.selling_plan_groups) {
      throw new Error(`No selling plan groups found for product: ${handle}`);
    }
    
    const sellingPlanGroup = data.selling_plan_groups.find(sellingPlan => sellingPlan.name === sellingPlanName);
    
    if (!sellingPlanGroup) {
      throw new Error(`Selling plan group not found: ${sellingPlanName}`);
    }
    
    const sellingPlan = sellingPlanGroup.selling_plans.find(sellingPlan => sellingPlan.name === sellingPlanName);
    
    if (!sellingPlan) {
      throw new Error(`Selling plan not found: ${sellingPlanName}`);
    }
    
    return sellingPlan.id;
  } catch (error) {
    console.error('Error in getSellingPlan:', error);
    throw error;
  }
};
